module.exports = __webpack_public_path__ + "static/media/success.d50ba45a.jpg";